import { FC } from 'react';
import { useStyles } from './CommunicationModal.styles';
import { RockyModal } from '@shared/components/RockyModal';
import { UserInfo } from '@shared/interfaces/UserInfo';
import { FlagPermissionsData } from '@modules/HappinessModule/pages/FlagPage/interfaces/FlagPermissionsData';
import { CommunicationModalComponents } from '../../../enums/CommunicationModalComponents';
import UserNotified from './components/UserNotified';
import ReminderMessage from './components/ReminderMessage';
import EmailWillBeSentWhenUserIsAssignedToTom from './components/EmailWillBeSentWhenUserIsAssignedToTom';
import WaitingForNHDetailsModal from './components/WaitingForNHDetailsModal';

export interface Props {
  saveFlagWithNewConfidentiality: (isConfidential: boolean) => void;
  step: CommunicationModalComponents;
  setStep: (step: CommunicationModalComponents) => void;
  userInfo: UserInfo;
  userFlagPermissions: FlagPermissionsData;
  isOpen: boolean;
  onClose: () => void;
  isNHRequestedWithoutTom?: boolean;
  isNewFlag: boolean;
}

const CommunicationModal: FC<Props> = ({
  userInfo,
  saveFlagWithNewConfidentiality,
  step,
  setStep,
  isNewFlag,
  ...props
}) => {
  const styles = useStyles();

  const ModalViews = {
    [CommunicationModalComponents.UserNotified]: (
      <UserNotified
        isNewFlag={isNewFlag}
        userInfo={userInfo}
        onClose={props.onClose}
        setStep={setStep}
        saveFlagWithNewConfidentiality={saveFlagWithNewConfidentiality}
      />
    ),
    [CommunicationModalComponents.ReminderMessage]: (
      <ReminderMessage
        userInfo={userInfo}
        onClose={props.onClose}
        isNewFlag={isNewFlag}
        saveFlagWithNewConfidentiality={saveFlagWithNewConfidentiality}
      />
    ),
    [CommunicationModalComponents.EmailWillBeSentWhenUserIsAssignedToTom]: (
      <EmailWillBeSentWhenUserIsAssignedToTom userInfo={userInfo} onClose={props.onClose} />
    ),
    [CommunicationModalComponents.WaitingForNHDetails]: <WaitingForNHDetailsModal onClose={props.onClose} />,
  };

  return (
    <RockyModal
      title={
        step === CommunicationModalComponents.EmailWillBeSentWhenUserIsAssignedToTom ||
        step === CommunicationModalComponents.WaitingForNHDetails
          ? 'Waiting for NH details'
          : 'Communicating NewHome process'
      }
      modalStyles={styles.modal}
      {...props}
      backdropClose={false}
    >
      {ModalViews[step]}
    </RockyModal>
  );
};

export default CommunicationModal;
